import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=6a0bdac2&scoped=true&"
import script from "./UserOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=6a0bdac2&prod&scoped=true&lang=css&"
import style1 from "./UserOnboarding.vue?vue&type=style&index=1&id=6a0bdac2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0bdac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VCheckbox,VCol,VHover,VIcon,VRow,VSheet,VSpacer})
